import { useMemo, useState } from 'react';

type UseCartCouponAffectedProductsParams = {
  productNames: string[];
  maxVisible?: number;
};

export const useCartCouponAffectedProducts = (params: UseCartCouponAffectedProductsParams) => {
  const { productNames, maxVisible } = params;
  const [expanded, setExpanded] = useState(false);

  const visibleProducts = useMemo(() => {
    if (!maxVisible || expanded || productNames.length <= maxVisible) {
      return productNames;
    }

    return productNames.slice(0, maxVisible);
  }, [expanded, maxVisible, productNames]);

  const hiddenCount = maxVisible && !expanded ? Math.max(productNames.length - maxVisible, 0) : 0;

  return {
    visibleProducts,
    hiddenCount,
    expanded,
    expand: () => setExpanded(true),
  };
};
